/* Product page behaviour: mystery-pack configurator, gallery, size guide, sticky bar. */
(function () {
  'use strict';
  var T = window.theme || { strings: {} };
  var S = T.strings;

  function money(cents) { return window.MysteryCore.formatMoney(cents, T.moneyFormat); }

  /* ---------------- Mystery configurator ---------------- */
  class MysteryForm extends HTMLElement {
    connectedCallback() {
      if (!window.MysteryCore) return;
      var raw = JSON.parse(this.querySelector('[data-product-json]').textContent);
      this.model = window.MysteryCore.createModel(raw);
      this.isDefault = raw.options.length === 1 && raw.options[0].name === 'Title' && raw.variants.length === 1;
      this.form = this.querySelector('form');
      this.variantInput = this.querySelector('[data-variant-input]');
      this.qtyInput = this.querySelector('[data-qty-input]');
      this.atc = this.querySelector('[data-atc]');
      this.atcLabel = this.querySelector('[data-atc-label]');
      this.errorEl = this.querySelector('[data-error]');
      this.section = this.closest('[data-section]');
      this.selected = this.model.options.map(function () { return null; });
      if (this.isDefault) this.selected = [raw.options[0].values[0]];

      this.applyUrlPreselection();
      this.addEventListener('change', this.onChange.bind(this));
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.setupSticky();
      this.update();
    }

    /* Deep link: ?variant=123 preselects that exact variant (useful for ads). */
    applyUrlPreselection() {
      var id = Number(new URLSearchParams(window.location.search).get('variant'));
      var v = id && this.model.variants.find(function (x) { return x.id === id; });
      if (!v) return;
      var self = this;
      v.options.forEach(function (value, i) {
        var input = Array.prototype.find.call(self.querySelectorAll('[data-option-index="' + i + '"]'), function (r) { return r.value === value; });
        if (input) { input.checked = true; self.selected[i] = value; }
      });
    }

    onChange(e) {
      var t = e.target;
      if (t.matches('[data-option-index]')) this.selected[Number(t.dataset.optionIndex)] = t.value;
      if (t.matches('[data-qty-input]')) {
        var q = parseInt(t.value, 10);
        t.value = isNaN(q) ? 1 : Math.min(10, Math.max(1, q));
      }
      this.hideError();
      this.update();
    }

    update() {
      var C = window.MysteryCore, m = this.model, self = this;

      // Disable values that can't be bought with the other choices made
      var avail = C.optionAvailability(m, this.selected);
      this.querySelectorAll('[data-option-index]').forEach(function (input) {
        var i = Number(input.dataset.optionIndex);
        var ok = !!avail[i][input.value];
        input.disabled = !ok;
        input.parentElement.title = ok ? '' : S.soldOut;
        if (!ok && input.checked) { input.checked = false; self.selected[i] = null; }
      });

      var sum = C.priceSummary(m, this.selected);
      var samePrice = m.variants.every(function (v) { return v.price === m.variants[0].price; });
      var priceText = (sum.exact || samePrice ? '' : (S.from || 'from') + ' ') + money(sum.total);
      this.setText('[data-summary-total]', money(sum.total));
      var choice = m.options.length > 1 || !this.isDefault
        ? this.selected.map(function (v, i) { return v ? (m.options.length > 1 ? m.options[i].name + ': ' : '') + v : null; }).filter(Boolean).join(' · ')
        : '';
      this.setText('[data-summary-choice]', choice);
      if (this.section) {
        var hp = this.section.querySelector('[data-headline-price]');
        if (hp) hp.textContent = priceText.charAt(0).toUpperCase() + priceText.slice(1);
        var sp = this.section.querySelector('[data-sticky-price]');
        if (sp) sp.textContent = money(sum.total);
      }

      var result = C.validate(m, this.selected, this.qtyInput ? this.qtyInput.value : 1);
      this.result = result;
      if (result.ok) {
        this.variantInput.value = result.variant.id;
        this.variantInput.disabled = false;
      } else if (!this.isDefault) {
        this.variantInput.value = '';
        this.variantInput.disabled = true;
      }
      var label;
      if (result.ok) label = S.addToCart + ' · ' + money(sum.total);
      else if (result.reason === 'missing') label = this.chooseLabel(result.missing);
      else if (result.reason === 'soldout') label = S.soldOut;
      else if (result.reason === 'unavailable') label = S.unavailable;
      else label = S.addToCart;
      this.atcLabel.textContent = label;
      this.atc.setAttribute('aria-disabled', result.reason === 'soldout' || result.reason === 'unavailable' ? 'true' : 'false');
      this.querySelectorAll('.mystery__step').forEach(function (s) { s.classList.remove('is-invalid'); });

      if (result.ok && !this.isDefault && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', result.variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    chooseLabel(index) {
      var name = this.model.options[index] ? this.model.options[index].name : '';
      if (this.model.options.length === 1) return S.chooseSize;
      return (S.choose || 'Choose') + ' ' + name.toLowerCase();
    }

    setText(sel, text) {
      var el = this.querySelector(sel) || (this.section && this.section.querySelector(sel));
      if (el) el.textContent = text;
    }

    showError(result) {
      var msg;
      if (!result) msg = S.genericError;
      else if (typeof result === 'string') msg = result;
      else if (result.reason === 'missing') msg = this.chooseLabel(result.missing);
      else if (result.reason === 'soldout') msg = S.soldOut;
      else if (result.reason === 'unavailable') msg = S.unavailable;
      else msg = S.genericError;
      this.errorEl.textContent = msg;
      this.errorEl.hidden = false;
      if (result && result.reason === 'missing') {
        var el = this.querySelector('[data-step="' + result.missing + '"]');
        if (el) {
          el.classList.add('is-invalid');
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var first = el.querySelector('input:not(:disabled)');
          if (first) first.focus({ preventScroll: true });
        }
      }
    }

    hideError() { this.errorEl.hidden = true; this.errorEl.textContent = ''; }

    onSubmit(e) {
      e.preventDefault();
      this.update();
      var r = this.result;
      if (!r || !r.ok) { this.showError(r); return; }
      var self = this;
      this.atc.classList.add('is-loading');
      this.atc.setAttribute('aria-busy', 'true');
      window.Cart.add([{ id: r.variant.id, quantity: parseInt(this.qtyInput.value, 10) || 1 }])
        .then(function () { self.hideError(); })
        .catch(function (err) { self.showError(err && err.message ? err.message : S.genericError); })
        .finally(function () { self.atc.classList.remove('is-loading'); self.atc.removeAttribute('aria-busy'); });
    }

    setupSticky() {
      var bar = this.section && this.section.querySelector('[data-sticky-atc]');
      if (!bar || !('IntersectionObserver' in window)) return;
      var self = this;
      var btn = bar.querySelector('[data-sticky-btn]');
      var io = new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        btn.tabIndex = show ? 0 : -1;
      });
      io.observe(this.atc);
      btn.addEventListener('click', function () {
        if (self.result && self.result.ok) self.form.requestSubmit();
        else self.showError(self.result);
      });
    }
  }
  if (!customElements.get('mystery-form')) customElements.define('mystery-form', MysteryForm);

  /* ---------------- Gallery, zoom, size guide ---------------- */
  document.querySelectorAll('[data-section]').forEach(function (section) {
    var track = section.querySelector('[data-gallery-track]');
    var idx = section.querySelector('[data-gallery-index]');
    if (track && idx) {
      track.addEventListener('scroll', function () {
        idx.textContent = Math.round(track.scrollLeft / track.clientWidth) + 1;
      }, { passive: true });
    }

    var zoomModal = section.querySelector('[data-zoom-modal]');
    var zoomImg = section.querySelector('[data-zoom-img]');
    section.querySelectorAll('[data-zoom]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!zoomModal || !zoomModal.showModal) return;
        zoomImg.src = btn.dataset.zoom;
        zoomImg.alt = btn.dataset.zoomAlt || '';
        zoomModal.showModal();
      });
    });

    var guide = section.querySelector('[data-size-guide]');
    section.querySelectorAll('[data-open-size-guide]').forEach(function (btn) {
      btn.addEventListener('click', function () { if (guide && guide.showModal) guide.showModal(); });
    });

    section.querySelectorAll('dialog').forEach(function (dlg) {
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || e.target.closest('[data-close-modal]')) dlg.close();
      });
    });
  });
})();
